"use client";

import {JSX} from "react";

import type {InquiryFormInstance} from "@/features/rental/inquiry-form/inquiry-form.model";

import {useTranslation} from "@/shared/i18n";
import {TextField} from "@/shared/ui/form/fields";
import {TextareaField} from "@/shared/ui/form/fields/textarea-field";
import {PhoneField} from "@/shared/ui/form/phone-input";

import "./styles/inquiry-form-fields.scss";

export function InquiryFormFields({model, formId}: {model: InquiryFormInstance; formId: string}): JSX.Element {
    const {t} = useTranslation("booking");

    return (
        <form
            id={formId}
            className="inquiry-form"
            onSubmit={(e) => {
                e.preventDefault();
                void model.submit();
            }}
        >
            <div className="inquiry-form__row">
                <TextField
                    id="inquiry-first-name"
                    model={model.firstName}
                    label={t("firstName")}
                    placeholder={t("firstName")}
                    autoComplete="given-name"
                    name="given-name"
                />
                <TextField
                    id="inquiry-last-name"
                    model={model.lastName}
                    label={t("lastName")}
                    placeholder={t("lastName")}
                    autoComplete="family-name"
                    name="family-name"
                />
            </div>

            <TextField
                id="inquiry-email"
                model={model.email}
                label={t("email")}
                placeholder="name@example.com"
                type="email"
                autoComplete="email"
                name="email"
            />

            <PhoneField showFlag model={model.phone} label={t("mobilePhone")} />

            <TextareaField
                id="inquiry-message"
                model={model.message}
                label={t("inquiryMessage")}
                placeholder={t("inquiryMessagePlaceholder")}
                rows={4}
            />
        </form>
    );
}
